import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, inject, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-about',
  imports: [RouterModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent implements AfterViewInit {
  private platformId = inject(PLATFORM_ID);

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId) || !('IntersectionObserver' in window)) {
      return;
    }

    const target = document.getElementById('aboutUsHome');
    const container = document.getElementById('spline-container');

    if (!target || !container) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;

      const iframe = document.createElement('iframe');
      iframe.src = 'https://my.spline.design/untitled-31feba7267c3ba3a0f8f023f897a6bf2/';
      iframe.width = '100%';
      iframe.height = '456';
      iframe.loading = 'lazy';
      iframe.title = 'Mapa de territorio Tracsa CAT';
      iframe.style.border = 'none';

      container.replaceChildren(iframe);
      observer.disconnect();
    });

    observer.observe(target);
  }
}
